'use strict';

import * as dom from './lib/dom';

function scrollToDiv() {
	if(window.location.href.indexOf("tickets_content") > -1) {
	  	const elToScroll = document.getElementById('tickets_content');
	  	dom.scrollIt(elToScroll, 200, 'easeInOutQuint');
   	}
}

export default function(){
	window.addEventListener('load', function() {
        scrollToDiv();
  	});
}
